import React, { useState, useRef, useLayoutEffect } from "react";
import gsap from "gsap";
import { Link } from "react-router-dom";
import "../aseets/css/HeroCarousel.css";

import abstract from "../aseets/video/abstract-hero.mp4";
import glob from "../aseets/gallery/glob.png";
import arrow from "../aseets/gallery/arrow.png";
import award from "../aseets/gallery/award.png";
import google from "../aseets/gallery/google-icon.PNG";
import microsoft from "../aseets/gallery/microsoft.PNG";
import shopify from "../aseets/gallery/shopify.png";

import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


const HeroSection = () => {

  
  const [index, setIndex] = useState(0);
  const slidesRef = useRef([]);

  useLayoutEffect(() => {
    gsap.fromTo(
      slidesRef.current[index],
      { opacity: 0, y: 30 },
      { opacity: 1, y: 0, duration: 0.9, ease: "power3.out" }
    );
  }, [index]);

  const next = () => setIndex((prev) => (prev + 1) % 2);
  const prev = () => setIndex((prev) => (prev - 1 + 2) % 2);

  return (
    <section className="gm-hero-carousel">
      {/* SLIDE WRAPPER */}
      <div className="gm-carousel-track">

        {/* ================= SLIDE 1 : VIDEO ================= */}
        {index === 0 && (
          <div
            className="gm-slide gm-video-slide"
            ref={(el) => (slidesRef.current[0] = el)}
          >
            <video
              className="gm-bg-video"
              autoPlay
              muted
              loop
              playsInline
            >
              <source src={abstract} type="video/mp4" />
            </video>

            <div className="gm-video-overlay">
              <h1>
                Turning Digital Noise<br />
                <span>Into Business Clarity</span>
              </h1>

              <p>Strategy · Systems · Scale</p>

              <div className="gm-scroll-hint">
                Scroll to see how
                <span></span>
              </div>
            </div>
          </div>
        )}

        {/* ================= SLIDE 2 : CONTENT ================= */}
        {index === 1 && (
          <div
            className="gm-slide gm-content-slide"
            ref={(el) => (slidesRef.current[1] = el)}
          >
            <div className="gm-hero-container">
              {/* LEFT */}
              <div className="gm-hero-left">
                <h1 className="gm-hero-title">
                  We Are Solution <br />
                  Oriented{" "}
                  <span className="gm-highlight">
                    Digital
                    <span className="gm-highlight-box"></span>
                    <span className="gm-cursor-dot">
                      <img src={arrow} alt="" />
                    </span>
                  </span>
                  <br />
                  Agency
                </h1>

                <p className="gm-hero-sub">
                  Best marketing company in Pune.
                </p>

                <div className="gm-hero-actions">
                  <button className="gm-btn-primary">Get Started</button>
                  <Link to="/about-us">
                    <button className="gm-btn-secondary">
                      How It Works
                    </button>
                  </Link>
                </div>

                <div className="gm-trusted">
                  <span>Trusted By</span>
                  <div className="gm-trusted-logos">
                    <img src={google} alt="" />
                    <img src={microsoft} alt="" />
                    <img src={shopify} alt="" />
                  </div>
                </div>
              </div>

              {/* RIGHT */}
              <div className="gm-hero-right">
                <div className="gm-circle-ring"></div>

                <img src={glob} className="gm-hero-image" alt="" />

                <div className="gm-award-card">
                  <img src={award} alt="" />
                  <strong>Best Agency</strong>
                  <span>Award</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* CONTROLS */}
      <div className="gm-carousel-controls">
        <button onClick={prev}>←</button>
        <button onClick={next}>→</button>
      </div>
    </section>
  );
};

export default HeroSection;
